/**
 * 썸네일 URL 헬퍼
 *
 * 게임/벤더 썸네일을 백엔드 /thumb 프록시로 감싸 WebP 리사이즈·캐싱된 이미지를 받는다.
 * - 게임 썸네일: 외부 벤더 CDN 전체 URL (예: https://img.dyn123.com/....png)
 * - 벤더 썸네일: 우리 이미지 서버의 파일 ID (예: b5b50da2...) → IMG_BASE 와 결합한 전체 URL
 *
 * 두 경우 모두 최종적으로 https://img-jp.../thumb?u=<원본URL>&w=<width> 형태로 변환한다.
 */

const IMG_BASE = (process.env.REACT_APP_IMG_URL || '').replace(/\/+$/, '')
// /thumb 프록시 베이스. 이미지 서버 도메인과 동일.
const THUMB_BASE = IMG_BASE

// 카드 표시 기준 기본 너비(px). 레티나 고려해 표시 크기의 약 2배.
const DEFAULT_WIDTH = 300

/**
 * 외부 전체 URL(게임 썸네일)을 프록시 URL로 변환.
 * @param {string} originalUrl
 * @param {number} [width]
 * @returns {string}
 */
export function gameThumb(originalUrl, width = DEFAULT_WIDTH) {
  if (!originalUrl) return ''
  if (!THUMB_BASE) return originalUrl
  // 이미 프록시 URL이면 중복 래핑 방지
  if (originalUrl.includes('/thumb?u=')) return originalUrl
  return `${THUMB_BASE}/thumb?u=${encodeURIComponent(originalUrl)}&w=${width}`
}

/**
 * 우리 이미지 서버의 파일 ID(벤더/배너 썸네일)를 프록시 URL로 변환.
 * @param {string} id - 이미지 파일 ID (UUID 형태)
 * @param {number} [width]
 * @returns {string}
 */
export function assetThumb(id, width = DEFAULT_WIDTH) {
  if (!id) return ''
  // 원본 파일의 전체 URL을 만든 뒤 프록시로 감싼다.
  const originalUrl = `${IMG_BASE}/${id}`
  if (!THUMB_BASE) return originalUrl
  return `${THUMB_BASE}/thumb?u=${encodeURIComponent(originalUrl)}&w=${width}`
}
